export const types = {
    SET_CREATE_INFO: 'SET_CREATE_INFO',
    SET_CREATE_TRIGGER: 'SET_CREATE_TRIGGER',
    SET_CREATE_ACTION: 'SET_CREATE_ACTION',
    RESET_CREATE_INFO: 'RESET_CREATE_INFO',
    RESET_CREATE_TRIGGER: 'RESET_CREATE_TRIGGER',
    RESET_CREATE_ACTION: 'RESET_CREATE_ACTION',
    RESET_CREATE: 'RESET_CREATE',
    SET_UPDATE_INFO: 'SET_UPDATE_INFO',
    SET_UPDATE_TRIGGER: 'SET_UPDATE_TRIGGER',
    SET_UPDATE_ACTION: 'SET_UPDATE_ACTION',
    RESET_UDPATE: 'RESET_UDPATE'
};

const initialState = {};

export default (state = initialState, action) => {
    const payload = action.payload;
    switch (action.type) {
        case types.SET_CREATE_INFO: {
            return {
                ...state,
                create_info: payload
            };
        }
        case types.SET_CREATE_TRIGGER: {
            return {
                ...state,
                create_trigger: payload
            };
        }
        case types.SET_CREATE_ACTION: {
            return {
                ...state,
                create_action: payload
            };
        }
        case types.RESET_CREATE_INFO: {
            const currentState = {...state};
            delete state['create_info'];
            return currentState;
        }
        case types.RESET_CREATE_TRIGGER: {
            const currentState = {...state};
            delete state['create_trigger'];
            return currentState;
        }
        case types.RESET_CREATE_ACTION: {
            const currentState = {...state};
            delete state['create_action'];
            return currentState;
        }
        case types.RESET_CREATE: {
            const currentState = {...state};
            delete state['create_info'];
            delete state['create_trigger'];
            delete state['create_action'];
            return currentState;
        }
        case types.SET_UPDATE_INFO: {
            return {
                ...state,
                update_info: payload
            };
        }
        case types.SET_UPDATE_TRIGGER: {
            return {
                ...state,
                update_trigger: payload
            };
        }
        case types.SET_UPDATE_ACTION: {
            return {
                ...state,
                update_action: payload
            };
        }
        case types.RESET_UDPATE: {
            const currentState = {...state};
            delete state['update_info'];
            delete state['update_trigger'];
            delete state['update_action'];
            return currentState;
        }
        default:
            // ALWAYS have a default case in a reducer
            return state;
    }
}

export const actions = {
    setCreateInfo: (payload = {}) => ({
        type: types.SET_CREATE_INFO,
        payload
    }),
    setCreateTrigger: (payload = {}) => ({
        type: types.SET_CREATE_TRIGGER,
        payload
    }),
    setCreateAction: (payload = {}) => ({
        type: types.SET_CREATE_ACTION,
        payload
    }),
    resetCreateInfo: () => ({
        type: types.RESET_CREATE_INFO
    }),
    resetCreateTrigger: () => ({
        type: types.RESET_CREATE_TRIGGER
    }),
    resetCreateAction: () => ({
        type: types.RESET_CREATE_ACTION
    }),
    resetCreate: () => ({
        type: types.RESET_CREATE
    }),
    setUpdateInfo: (payload = {}) => ({
        type: types.SET_UPDATE_INFO,
        payload
    }),
    setUpdateTrigger: (payload = {}) => ({
        type: types.SET_UPDATE_TRIGGER,
        payload
    }),
    setUpdateAction: (payload = {}) => ({
        type: types.SET_UPDATE_ACTION,
        payload
    }),
    resetUpdate: () => ({
        type: types.RESET_UPDATE
    })
}
